<template>
  <!--弹框3 开始-->
  <div class="dia-info">
    <el-dialog :visible.sync="frameHomeSoldDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter" :customClass="dialogLanguage">
      <div style="width:100%;text-align: center; ">
        <div><img src="/static/img/frame/sold-blue.png" class="frame-big-img"></div>
        <div class="frame-text-hotel-sold wordBreak">
          {{$t('noInventory')}}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="white_button" style="width: auto;" @click="cityRouterLink">Home</el-button>
        <el-button type="primary" class="booknow_button" style="margin-left: 15px; width: auto; float: none;" @click="goToRoom">{{$t('bookAotherRoom')}}</el-button>
      </span>
    </el-dialog>
  </div>
  <!--弹框3 结束-->
  <!--引入方式-->
  <!-- <frameHomeSold :frameHomeSoldDialog="frameHomeSoldDialog"></frameHomeSold> -->
</template>

<script>
import { getCityId } from '@/request/hotel.js'
export default {
  name: 'frameHomeSold',
  props: ['frameHomeSoldDialog', 'nationality'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: '',
      cityname: '',
      language: this.common.languageSet(this),
      hotelname: '',
      dialogLanguage: 'dialog-en'
    }
  },
  watch: {
    language: function (newCur, oldCur) {
      this.getCityIdFun()

      // 图片
      this.dialogLanguage = 'dialog-' + newCur
    }
  },
  created () {
    setInterval(() => {
      this.language = this.common.languageSet(this)
    }, 200)
    this.dialogLanguage = 'dialog-en'
    var query = this.$route.query
    if (JSON.stringify(query) !== '{}') {
      this.adult = parseInt(this.$route.query.adult)
      this.child = parseInt(this.$route.query.child)
      this.room = parseInt(this.$route.query.room)
      this.startdate = this.$route.query.start_date
      this.enddate = this.$route.query.end_date
    }
    var searchData = localStorage.getItem('searchData')
    if (searchData !== '{}' && searchData !== null) {
      var params = JSON.parse(searchData)
      if (this.adult === undefined || this.adult === null || this.adult === '') {
        this.adult = parseInt(params.adult)
      }
      if (this.child === undefined || this.child === null || this.child === '') {
        this.child = parseInt(params.child)
      }
      if (this.room === undefined || this.room === null || this.room === '') {
        this.room = parseInt(params.room)
      }
      if (this.startdate === undefined || this.startdate === null || this.startdate === '' || this.startdate === 'NAN-NAN-NAN') {
        this.startdate = params.start_date
      }
      if (this.enddate === undefined || this.enddate === null || this.enddate === '' || this.enddate === 'NAN-NAN-NAN') {
        this.enddate = params.end_date
      }
    }
    // 获取城市ID
    this.getCityIdFun()
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    goToRoom () {
      // 获取数据
      var path = this.$route.path
      if (path.indexOf('HotelDetail') !== -1) {
        window.location.reload()
        return false
      }

      var childNums = '[]'
      var searchData = localStorage.getItem('searchData')
      if (searchData !== '{}' && searchData !== null) {
        var params = JSON.parse(searchData)
        childNums = params.childNums
      }
      console.log('startdate', this.startdate)
      console.log('enddate', this.enddate)

      var searchJson = {'hotelid': this.hotelid, 'region': this.hotelname, 'start_date': this.startdate, 'end_date': this.enddate, 'room': this.room, 'adult': this.adult, 'child': this.child, 'childNums': childNums, 'nationality': this.nationality}
      this.$router.push({name: 'HotelDetail', query: searchJson})
    },
    // 获取城市ID
    getCityIdFun: function () {
      var query = this.$route.query
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.$route.query.hotelid
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'hotelname': true, 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
        if (this.language === 'zh') {
          this.cityname = this.city.chinese_name
          this.hotelname = this.city.hotelname
        } else {
          this.cityname = this.city.city
          this.hotelname = this.city.hotelname_en
        }
      })
    },
    // 城市跳转
    cityRouterLink: function () {
      // 点击返回首页 埋点记录
      this.clickPageAction('back_home', '', {'type': 'frameHomeSold'})

      var regionSel = {'value_en': this.city.city, 'value_zh': this.city.chinese_name, 'type_id': 1, 'type_data_id': this.city.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var cityname = this.city.city
      if (this.common.languageSet(this) === 'zh') {
        cityname = this.city.chinese_name
      }

      let d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth()
      var tian = d.getDate()
      var monthSelect = (month + 1) < 10 ? '0' + (month + 1).toString() : (month + 1).toString()
      var startDate = this.startdate
      if (this.startdate === '' || this.startdate === undefined) {
        startDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 1)
      }
      var endDate = this.enddate
      if (this.enddate === '' || this.enddate === undefined) {
        endDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 2)
      }

      var params = this.$route.params
      if (JSON.stringify(params) === '{}') {
        params = this.$route.query
      }
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }
      var childNums = '[]'
      if (JSON.stringify(params) !== '{}' && JSON.stringify(params.childNums) !== '{}' && params.childNums !== undefined) {
        childNums = params.childNums
      }

      var searchJson = {'type': 1, 'type_id': this.city.id, 'region': cityname, 'start_date': startDate, 'end_date': endDate, 'room': params.room, 'adult': params.adult, 'child': params.child, 'childNums': childNums, 'nationality': this.nationality}
      localStorage.setItem('searchData', JSON.stringify(searchJson))
      this.$router.push({name: 'HotelList', query: searchJson})
    }
  }
}
</script>

<style scoped>
.textcenter{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{height:40px; font-size: 16px;color: #4F4C4C;text-align: center; margin-top: 20px;}
.textcenter /deep/ .el-dialog{background-position: right bottom; background-color: #fff;background-size: 23%;}
.dia-info /deep/ .el-dialog__header{padding: 0;}
</style>



// WEBPACK FOOTER //
// src/components/public/frameHomeSold.vue